var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.081,
    height: 18.811,
    viewBox: "0 0 25.081 18.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-area",
    d: "M24.494,20.176a.59.59,0,0,1,.588.588v1.959a.59.59,0,0,1-.588.588H.588A.59.59,0,0,1,0,22.723V5.088A.59.59,0,0,1,.588,4.5H2.547a.59.59,0,0,1,.588.588V20.176Zm-6.236-11-4.149,2.768L9.93,6.376a.589.589,0,0,0-.975.049L4.7,13.514v5.095H23.514l-4.4-9.2a.588.588,0,0,0-.852-.23Z",
    transform: "translate(0 -4.5)",
    fill: "#6dc1c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArea);
export default __webpack_public_path__ + "static/media/chart_area.b8f4e20f44eba646260213b74cbc793b.svg";
export { ForwardRef as ReactComponent };